import apiRequest from "src/common/utils/apiRequest";
import { openDB, IDBPDatabase } from "idb";
import { NotificationSchema, Notification } from "src/common/types";

class notification {
  private DB_NAME = "NotificationDB";
  private db: IDBPDatabase<NotificationSchema> | null = null;
  status: string = "idle";

  constructor() {
    this.initDB();
  }

  initDB = async () => {
    try {
      const dbInstance = await openDB<NotificationSchema>(this.DB_NAME, 1, {
        upgrade(db) {
          if (!db.objectStoreNames.contains("notifications")) {
            db.createObjectStore("notifications", { keyPath: "id" });
          }
        },
      });

      this.db = dbInstance;
    } catch (e) {
      await this.resetDB();
    }
  };

  resetDB = async () => {
    await indexedDB.deleteDatabase(this.DB_NAME);

    this.db = null;

    await this.initDB();
  };

  addNotification = async (notification: Notification) => {
    try {
      if (!this.db) return;

      await this.db.put("notifications", {
        id: notification.id,
        title: notification.title,
        message: notification.message,
        type: notification.type,
        date: notification.date,
        status: notification.status,
        link: notification.link,
      });

      return true;
    } catch (error) {
      await this.resetDB();

      return false;
    }
  };

  async syncNotification() {
    this.status = "initializing";

    const API_REQUEST = new apiRequest("notifications/get", true, true);
    return await API_REQUEST.sendAndCache(
      "notifications",
      5000,
      {},
      async (data: { status: string; data: Notification[] }) => {
        if (data.status === "success") {
          this.status = "finalizing";

          let result = true;
          data.data.map(async (notification) => {
            const re = await this.addNotification(notification);
            if (!re) result = false;
          });

          if (result) {
            this.status = "synced";
          }
        }

        const timeout = setTimeout(() => {
          this.status = "idle";
          clearTimeout(timeout);
        }, 300);
      }
    );
  }

  getNotifications = async () => {
    if (!this.db) return;

    return await this.db.getAll("notifications");
  };

  deleteNotification = async (id: string) => {
    if (!this.db) return;

    const DB = this.db;

    const existing = await DB.get("notifications", id);
    if (!existing) return;

    const API_REQUEST = new apiRequest("notification/delete", true);

    await API_REQUEST.send(
      { id: id },
      async (data: { status: string; data: Notification[] }) => {
        if (data.status === "success") {
          await DB.delete("notifications", id);
        }
      }
    );

    return true;
  };

  markAsRead = async (id: string) => {
    if (!this.db) return;

    const DB = this.db;

    const existing = await DB.get("notifications", id);
    if (!existing) return;

    const API_REQUEST = new apiRequest("notification/read", true);

    await API_REQUEST.send(
      { id: id },
      async (data: { status: string; data: Notification[] }) => {
        if (data.status === "success") {
          existing.status = 1;
          await DB.put("notifications", existing);
        }
      }
    );

    return true;
  };
}

export default notification;
